// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5u-5";
export var imageContainer = "_5u-4";
export var metricsGrid = "_5u-2";
export var productDetailContainer = "_5u-1";
export var productListContainer = "_5u-0";
export var subscriberTableContainer = "_5u-3";